/* jshint esversion: 6, -W097 */
/* globals require */
(function (angular) {
    'use strict';
    /**
     * A directive that displays a RebatedProduct in the fast track form and
     * allows product receipts to be linked.
     */
    angular
        .module('enervee.fastTrack')
        .directive('fastTrackCartItem', fastTrackCartItem);


    fastTrackCartItem.$inject = [];
    function fastTrackCartItem() {
        return {
            restrict: 'E',
            scope: {
                product: '=',
                index: '=?',
                errors: '=',
            },
            bindToController: true,
            controllerAs: 'vm',
            controller: fastTrackCartItemController,
            template: require('@app/components/fastTrack/uploadReceiptsModal/fastTrackCartItem/fastTrackCartItemView.html'),
        };
    }

    fastTrackCartItemController.$inject = ['$scope', 'FastTrackUploadReceiptsService'];
    function fastTrackCartItemController($scope, FastTrackUploadReceiptsService) {
        var vm = this;
        vm.clearReceipt = FastTrackUploadReceiptsService.clearReceiptData;
        vm.duplicateReceipt = FastTrackUploadReceiptsService.duplicateReceiptData;
        vm.linkedProductID = "";

        vm.$onInit = function() {
            $scope.$watch('vm.product', function(product) {
                vm.receiptList = FastTrackUploadReceiptsService.getReceiptList(product);
            });
        };
    }
})(angular);
